import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Store from './views/Store.vue'
import Team from './views/Team.vue'
import ContactUs from './views/ContactUs.vue'
import About from './views/About.vue'
import Academy from './views/Academy.vue'
import Commercial from './views/Commercial.vue'
import ComingSoon from './views/ComingSoon.vue'
import Loading from './views/Loading.vue'
import TeamPicker from './views/TeamPicker.vue'
import RobosubAuv from './views/RobosubAuv.vue'
import NotFound from './views/NotFound.vue'
import SwiftAUV from './views/SwiftAUV.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Loading',
      component: Loading
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/coming-soon',
      name: 'ComingSoon',
      component: ComingSoon
    },
    {
      path: '/Store',
      name: 'Store',
      component: Store
    },
    {
      path: '/Team',
      name: 'Team',
      component: Team
    },
    {
      path: '/about_us',
      name: 'About',
      component: About
    },
    {
      path: '/academy',
      name: 'Academy',
      component: Academy
    },
    {
      path: '/contact_us/:type?',
      name: 'ContactUs',
      component: ContactUs,
      props: true
    },
    {
      path: '/commercial',
      name: 'Commercial',
      component: Commercial
    },
    {
      path: '/teams-picker',
      name: 'TeamPicker',
      component: TeamPicker
    },
    {
      path: '/auv',
      name: 'RobosubAuv',
      component: RobosubAuv
    },
    {
      path: '/swift-auv',
      name: 'SwiftAUV',
      component: SwiftAUV
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})
